<template>
  <modal
    class="project-select-modal"
    v-model="visible"
    width="980"
    :transfer="true"
    title="查询项目"
    :closable="true"
    :mask-closable="false"
    @on-cancel="returnPath">
    <div class="modal-main">
      <div class="filter">
        <Row>
          <Col span="18">
            <Form ref="filterForm" inline>
              <FormItem label="">
                <Input type="text" v-model="prjName" placeholder="项目名称">
                </Input>
              </FormItem>
              <!-- <FormItem label="项目编号">
                <Input type="text" v-model="prjNo" placeholder="项目编号">
                </Input>
              </FormItem> -->
              <FormItem label="">
                <Input type="text" v-model="ownerName" placeholder="建设单位">
                </Input>
              </FormItem>
              <FormItem label="">
                <Input type="text" v-model="contractorName" placeholder="施工单位">
                </Input>
              </FormItem>
              <FormItem label="">
                <Button type="primary" @click="search">查询</Button>
              </FormItem>
            </Form>
          </Col>
          <Col span="6">
            <div class="table-pager">
              <Button type="primary" ghost shape="circle" icon="ios-arrow-back"
                :disabled="pageIndex===1||totalItemCount===0"
                @click="prev"></Button>
              <div class="pager-info">
                <!-- {{ totalItemCount }} 条， -->第 {{ pageIndex }} 页 / 共 {{ pageCount }} 页
              </div>
              <Button type="primary" ghost shape="circle" icon="ios-arrow-forward"
                :disabled="pageIndex===pageCount||totalItemCount===0"
                @click="next"></Button>
            </div>
          </Col>
        </Row>
      </div>
      <div class="table-region">
        <Table :columns="columns" :data="prjList" stripe></Table>
      </div>
    </div>
    <div slot="footer">
      <i-button type="default" @click="returnPath">取消</i-button>
    </div>
    <modal
      class="project-detail-modal"
      v-model="showDetail"
      width="680"
      :transfer="true"
      title="项目详情"
      :closable="true"
      :mask-closable="false"
      @on-cancel="closeDetail">
      <div class="modal-main">
        <div class="table-region">
          <table class="brief-table">
            <tr
              v-for="(key,idx) in Object.keys(detail)"
              :key="idx">
              <td class="title">{{ key }}</td>
              <td>{{ detail[key] }}</td>
            </tr>
          </table>
        </div>
      </div>
      <div slot="footer">
        <i-button type="default" @click="closeDetail">关闭</i-button>
        <i-button type="primary" @click="choosePrj">选择</i-button>
      </div>
    </modal>
  </modal>
</template>

<script>
import Api from '../../api/Api.js'
import $ from 'jquery'
export default {
  name: 'project-select-modal',
  props: {
    show: Boolean
  },
  data () {
    return {
      loading: false,
      visible: false,
      prjName: '',
      prjNo: '',
      contractorName: '',
      ownerName: '',
      prjList: [],
      totalItemCount: 0,
      pageIndex: 1,
      columns: [
        {
          title: '工程名称',
          key: 'prjName'
        },
        {
          title: '建设单位',
          key: 'ownerName'
        },
        {
          title: '编号',
          key: 'prjNo',
          width: 180
        },
        {
          title: '操作',
          width: 150,
          render: (h, params) => {
            return h('span', null, [
              h('Button', {
                props: {
                  type: 'primary',
                  ghost: true,
                  size: 'small',
                  shape: 'circle'
                },
                style: {
                },
                on: {
                  click: () => {
                    // let userId = params.row.id
                    this.curTid = params.row.tid
                    this.getPrjDetail().then(() => {
                      this.showDetail = true
                    })
                  }
                }
              }, '查看'),
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small',
                  shape: 'circle'
                },
                style: {
                  marginLeft: '5px'
                },
                on: {
                  click: () => {
                    // let userId = params.row.id
                    this.curTid = params.row.tid
                    this.getPrjDetail().then(() => {
                      this.choosePrj()
                    })
                  }
                }
              }, '选择')
            ])
          }
        }
      ],
      showDetail: false,
      curTid: null,
      detail: {}
    }
  },
  watch: {
    'show': function (newVal) {
      this.visible = newVal
      if (newVal) {
        this.getPrjList()
      }
    }
  },
  computed: {
    pageCount () {
      return Math.ceil(this.totalItemCount / 20)
    }
  },
  mounted () {
    if (this.show) {
      this.visible = true
      this.getPrjList()
    }
  },
  activated () {
  },
  deactivated () {
  },
  methods: {
    choosePrj () {
      this.$emit('choose', this.detail)
      this.closeDetail()
      this.returnPath()
    },
    closeDetail () {
      this.showDetail = false
      this.curTid = null
      this.detail = {}
    },
    getPrjDetail () {
      return new Promise((resolve, reject) => {
        Api.Crawler.getZzZhuJianPrjDetail(this.curTid).then((res) => {
          // console.log(res)
          let raw = res.data
          let rawDom = $(raw)
          // console.log(rawDom)
          let tbodyDom = $(rawDom).find('.content_main')
          let trDoms = $(tbodyDom).find('tr')
          let dic = {}
          if (trDoms.length) {
            for (let i = 0; i < trDoms.length; i++) {
              let tr = trDoms[i]
              let key = $(tr).find('td').eq(0).text().trim()
              let value = $(tr).find('td').eq(1).text().trim()
              dic[key] = value
            }
          }
          this.detail = dic
          resolve(dic)
        }).catch(err => {
          this.$Message.error('获取项目详情失败!' + err.message)
          reject(err)
        })
      })
    },
    search () {
      this.pageIndex = 1
      this.totalItemCount = 0
      this.prjList = []
      this.getPrjList()
    },
    prev () {
      if (this.pageIndex === 0 || this.totalItemCount === 0) {
        return false
      }
      this.pageIndex--
      this.prjList = []
      this.getPrjList()
    },
    next () {
      if (this.pageIndex === this.pageCount || this.totalItemCount === 0) {
        return false
      }
      this.pageIndex++
      this.prjList = []
      this.getPrjList()
    },
    getPrjList () {
      Api.Crawler.listZzZhuJianPrj({
        prjName: this.prjName,
        prjNo: this.prjNo,
        ownerName: this.ownerName,
        contractorName: this.contractorName
      }, this.pageIndex).then((res) => {
        // console.log(res)
        let prjList = []
        let raw = res.data
        let rawDom = $(raw)
        // console.log(rawDom)
        let tableDom = $(rawDom).find('#ProjectList').find('table')
        let trDoms = $(tableDom).find('tr')
        if (trDoms.length) {
          for (let i = 1; i < trDoms.length; i++) {
            let tr = trDoms[i]
            let prjName = $(tr).find('td').eq(0).text()
            let ownerName = $(tr).find('td').eq(1).text()
            let prjNo = $(tr).find('td').eq(2).text()
            let tidHref = $(tr).find('td').eq(3).find('a').attr('href')
            let tid = tidHref.split('/')[tidHref.split('/').length - 1]
            prjList.push({
              prjName,
              ownerName,
              prjNo,
              tid
            })
          }
        }
        this.prjList = prjList
        let pagerDom = $(rawDom).find('.page-tile')
        let pagerLiDoms = $(pagerDom).find('li')
        let totalItem = parseInt($(pagerLiDoms[0]).text().match(/共 [0-9]+ 条数据/)[0].match(/[0-9]+/)[0])
        this.totalItemCount = totalItem
        console.log(this.prjList, this.totalItemCount)
      }).catch(err => {
        this.$Message.error('获取项目列表失败!' + err.message)
      })
    },
    returnPath () {
      this.$emit('close')
      this.$Modal.remove()
      this.visible = false
    }
  }
}
</script>

<style lang="less">
.table-pager {
  display: flex;
  flex-direction: row;
  align-items: center;
}
</style>
